export const SCAN_API_KEYS = {
  ETH: process.env.REACT_APP_ETHSCAN_API_KEY,
  BSC: process.env.REACT_APP_BSCSCAN_API_KEY,
  OPTIMISM: process.env.REACT_APP_OPTIMISMSCAN_API_KEY,
  ARBITRUM: process.env.REACT_APP_ARBISCAN_API_KEY,
  AVALANCHE: process.env.REACT_APP_AVALANCHESCAN_API_KEY,
};
